<template>
  <!-- 公共的详情 带富文本 -->
  <div class="cmp-detail-wrap" :class="{'mobile': _isMobile}">
    <div class="cmp-detail">
      <h1 class="g-title-1" v-if="!hideName">{{detailData.name}}</h1>
      <!-- <div class="des-box">
        <span>时间：20200201</span>
        <span>来源：张三</span>
      </div> -->
      <div class="g-detail-html trans" v-html="detailData.content"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    detailData: {
      type: Object,
      default() {
        return {
          name: '123',
          content: ''
        }
      }
    },
    hideName: {
      type: Boolean,
      default: false
    },
    // type: {
    //   type: String,
    //   default: '5'  // 1信息 2参观 3展览 4馆藏精品 5社教 6服务 7文化 8视频
    // },
  },
  data() {
    return {
      
    }
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.cmp-detail {
  .des-box {
    text-align: center;
    font-size: 18px;
    color: #666;
    span {
      margin-right: 20px;
    }
  }
  .g-detail-html {
    margin-top: 30px;
  }
}
</style>
